import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class SubscriptionKeyInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const apiKey = environment.webapi?.subscriptionKey;

    if (!apiKey) {
      return next.handle(req);
    }

    const cloned = req.clone({
      setHeaders: {
        'Ocp-Apim-Subscription-Key': apiKey
      }
    });

    return next.handle(cloned);
  }
}
